const register_employees_csv =
  'https://static.ekincare.com/sample_csvs/Employees-Registration-Sample.csv';

const register_employees_xlsx =
  'https://static.ekincare.com/sample_csvs/Employees-Registration-Sample.xlsx';

const deactivate_employees_csv =
  'https://static.ekincare.com/sample_csvs/Employee_deactivation.csv';
  
const deactivate_employees_xlsx =
  'https://static.ekincare.com/sample_csvs/Employee_deactivation.xlsx';
  
const register_family_members_csv =
  'https://static.ekincare.com/sample_csvs/Family-Member-Adddition.csv';
 
const register_family_members_xlsx =
  'https://static.ekincare.com/sample_csvs/Family-Member-Adddition.xlsx';

const pre_employment_bluk_upload_xlsx =
  'https://static.ekincare.com/sample_csvs/Pre-employment-new-sheet.xlsx';

const ppmc_bluk_upload_xlsx =
  'https://res.cloudinary.com/ekincare/raw/upload/v1688492084/sample_csvs/pre_employees_3.xlsx';

const team_upload_csv =
  'https://static.ekincare.com/sample_csvs/stepathon_team_upload.csv'

const team_upload_xlsx =
  'https://static.ekincare.com/sample_csvs/stepathon_team_upload.xlsx'

const member_upload_xlsx = 
  'https://static.ekincare.com/sample_csvs/individual_closed_upload_sample.xlsx'

const member_upload_csv =
  'https://static.ekincare.com/sample_csvs/individual_closed_upload_sample.csv'

export {
  register_employees_csv,
  register_employees_xlsx,
  deactivate_employees_csv,
  deactivate_employees_xlsx,
  register_family_members_csv,
  register_family_members_xlsx,
  pre_employment_bluk_upload_xlsx,
  team_upload_csv,
  team_upload_xlsx,
  member_upload_xlsx,
  member_upload_csv,
  ppmc_bluk_upload_xlsx
}